export enum EmailFromType {
  emailCompanyContributor = 'email_company_contributor',
  emailUser = 'email_user',
  emailGroup = 'email_group'
}
